import React from "react";

const ContentRight = ({ icon, value, parheading,
    parValue,
    heading,
    paricon,
    parentbadge,
    childbadge1a,
    childval1a, }) => {
    return (
        <div className="flex justify-end items-end w-full">
            <div className="flex items-center gap-2 w-full justify-end">
                <img src={paricon} alt={value} className="h-[35px] w-[35px]" />
                <div className="lg:max-w-[140px] max-h-[40px] h-full w-full  border border-[#056DB3] rounded-r-full rounded-l-full p-1 bg-[#ECEAE8] flex justify-between items-center">
                    <div className="h-6 w-6 bg-[#056DB3] rounded-full"></div>
                    <p className="text-sm mr-6 ">{parValue}{childval1a ? ` | ${childval1a}` : ''}</p>
                </div>
            </div>
        </div>
    );
};

export default ContentRight;